<script setup lang="ts">
const props = defineProps({
    blok: {
        type: Object,
        default: () => ({}),
    },
});

const { toLocaleUrl } = useLocaleUrl();

const href = computed(() => {
    const url = props.blok.downloadUrl;
    if (!url) return '#';
    // External links returned as-is by toLocaleUrl
    return toLocaleUrl(url.cached_url);
});
</script>

<template>
    <a
        :href="href"
        :target="blok.downloadUrl.target"
        :data-id="blok.downloadUrl['data-id']"
        :data-location="blok.downloadUrl['data-location']"
        :data-ceid="blok.downloadUrl['data-ceid']"
        title=""
        :class="`${
            blok.smaller ? 'px-3 py-2' : 'px-5 py-3'
        } inline-flex text-base font-medium text-center text-white bg-primary-700 rounded-lg shrink-0 hover:bg-primary-800 hover:scale-105 duration-300 motion-reduce:transition-none motion-reduce:hover:transform-none focus:ring-4 focus:outline-none focus:ring-primary-300 dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800`"
        role="button"
    >
        {{ blok.text }}
        <svg
            v-if="blok.showDownloadIcon"
            class="ml-2 -mr-1 w-5 h-5"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
        >
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M19.5 13.5L12 21m0 0l-7.5-7.5M12 21V3"
            ></path>
        </svg>
    </a>
</template>
